<template>
  <div>
    <button v-if="days === 0" 
            class="btn btn-sm" 
            :class="buttonCss" 
            @click="$emit('click')">Remortgage Now!</button>
    <button v-else 
            class="btn btn-sm" 
            :class="buttonCss" 
            @click="$emit('click')">{{ days }} days to remortgage</button>
  </div>
</template>

<script>
export default {
  name: "DaysRemainingButton",
  
  props: {
    days: {
      type: Number,
      default: 0
    }
  },
  
  computed: {
    buttonCss() {
      if (this.days < 30) return "btn-danger"
      else if (this.days < 90) return "btn-warning"
      else return "btn-success"
    }
  }
}
</script>

<style scoped>

</style>